// extracted by mini-css-extract-plugin
module.exports = {"NoBackground":"feedBackGlobal_NoBackground__J0SW5"};